import { Grid, Tooltip, Typography } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import useStyles from "../../../themes/style.js";
import { IoMdDownload } from "react-icons/io";
import { Document, Page, pdfjs } from "react-pdf";
import "../../../css/view-resume.css"

import axios from "axios";

const PolicyHandBook = () => {
  const classes = useStyles();
  const [pdfURL, setPdfURL] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [numPages, setNumPages] = useState(0);
  const token = localStorage.getItem("token");
  const [textItems, setTextItems] = useState([]);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const TextLayerWithHighlights = ({ textItems, wordsToHighlight }) => {
    return (
      <div className="textLayer">
        {textItems.map((item, index) => (
          <span key={index} style={{ ...item.transform }}>
            {highlightWords(item.str, wordsToHighlight)}
          </span>
        ))}
      </div>
    );
  };

  const highlightWords = (text, wordsToHighlight) => {
    const regex = new RegExp(`(${wordsToHighlight.join("|")})`, "gi");
    return text
      .split(regex)
      .map((part, index) =>
        wordsToHighlight.some(
          (word) => word.toLowerCase() === part.toLowerCase(),
        ) ? (
          <mark key={index}>{part}</mark>
        ) : (
          part
        ),
      );
  };

  const fetchData = async () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}employee/getPolicyHandBook`,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.status == "200") {
        const file = response.data;
        setPdfFile(file);

        const url = URL.createObjectURL(file);
        setPdfURL(url); // Store URL for use in the iframe

        console.log(typeof response.data);
      }
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Policy Handbook" />
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" spacing={2}>
        <div className={` ${classes.inputRoot} `}>
          <div
            className={classes.inputRoot}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Typography variant="subtitle2">Policy Handbook</Typography>
            <Typography
              variant="subtitle2"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
              }}
            >
              <>
                <Tooltip
                  title="Dowmload"
                  placement="right"
                  aria-label="download"
                >
                  <a
                    style={{ fontSize: "1.3rem", color: "#29b229" }}
                    href={pdfURL}
                  >
                    <IoMdDownload />
                  </a>
                </Tooltip>
              </>
            </Typography>
          </div>
        </div>
        <div
          style={{
            boxShadow:
              "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em",
            marginBottom: "20px",
            maxHeight:"max-content",
            overflow:"auto"
          }}
        >
          <Document
            file={pdfFile}
            onLoadSuccess={onDocumentLoadSuccess}
            width="100%"
          >
            {Array.from(new Array(numPages), (el, index) => (
              <div key={`page_${index + 1}`} className="page">
                <Page
                  pageNumber={index + 1}
                  renderTextLayer={false}
                  customTextRenderer={() => (
                    <TextLayerWithHighlights
                      textItems={textItems}
                      wordsToHighlight={["HRMS", "JAVA", "Indeed"]}
                    />
                  )}
                />
              </div>
            ))}
          </Document>
        </div>
      </Grid>
    </div>
  );
};

export default PolicyHandBook;
